import { render, staticRenderFns } from "./TypeConfirmModal.vue?vue&type=template&id=f1e4e3a8&scoped=true&"
import script from "./TypeConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./TypeConfirmModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e4e3a8",
  null
  
)

export default component.exports